import { render, staticRenderFns } from "./index-banner-right.vue?vue&type=template&id=149baa62&scoped=true&"
import script from "./index-banner-right.vue?vue&type=script&lang=js&"
export * from "./index-banner-right.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149baa62",
  null
  
)

export default component.exports